import React, { useEffect, useState } from "react";
import { ActionIcon, Tooltip } from "@mantine/core";
import { IconArrowUp } from "@tabler/icons-react";
import { motion, AnimatePresence } from "framer-motion";
import { useTranslation } from "react-i18next";
import "./styles.scss";

const ScrollToTop: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 200) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, scale: 0.8, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.8, y: 20 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
          className="scroll-to-top-container"
        >
          <Tooltip
            label={t("common.scrollToTop")}
            position="left"
            withArrow
            offset={8}
          >
            <ActionIcon
              onClick={scrollToTop}
              size="lg"
              radius="xl"
              variant="gradient"
              gradient={{ from: "violet", to: "blue", deg: 90 }}
              className="scroll-to-top-button"
              aria-label={t("common.scrollToTop")}
            >
              <IconArrowUp size={20} />
            </ActionIcon>
          </Tooltip>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ScrollToTop;
